const FlagWorld = props => (
	<svg height="28" width="28" viewBox="0 0 200 200" {...props}>
		<rect fill="#4758a9" width="200" height="200" />
		<polygon
			fill="#c8d838"
			points="40.09 102.46 39.19 90.93 25.69 80 37.99 80 40.69 86 43.08 86 42.85 73.45 69.67 69 68.33 55.67 71.67 47.67 66.67 42.33 59 38.33 46.33 42.33 40.33 25.67 21.67 12.33 -6.67 0.33 -32.79 11 -34.59 18.65 -16 31.67 -12.67 66.33 13.33 81 35.29 97.31 22.67 121 41.59 136.94 37.69 177.13 45.48 182.53 73.07 137.55 82.07 131.85 79.37 118.96 40.09 102.46"
		/>
		<polygon fill="#c8d838" points="38 -7.67 61.98 10.39 62.67 25.67 69.67 31.85 92.57 2.9 80.87 -16.3 38 -7.67" />
		<polygon
			fill="#c8d838"
			points="283.2 25.79 216.92 12.6 187 15.67 171.67 27 149 25.67 153.67 11.67 140.33 6.33 125.46 26.99 126.95 36.59 137.45 26.39 138.35 30.59 127.86 40.49 118.56 45.58 119.67 31.67 116.16 32.39 108.33 45 117.67 47 117 56.08 99.67 55.67 104.82 64.48 109.29 66.58 117.37 61.78 120.36 65.38 122.76 65.68 122.16 59.68 129.35 66.88 135 59.67 133.55 68.97 145 72.33 149 76.33 155.67 92.33 170.33 93 169.67 86.33 160.33 76.33 159.67 67 173.67 80.33 183 101.67 189.67 108.33 204.33 92.67 214.22 110.96 229.82 102.86 233.42 79.47 241.21 87.27 268.5 56.68 278.1 65.08 295.49 34.79 283.2 25.79"
		/>
		<polygon
			fill="#c8d838"
			points="143.15 78.67 114.36 70.88 99.36 84.67 99.67 100.56 117.36 105.06 125.76 145.25 136.85 151.25 157 104.33 145 98.33 143.15 78.67"
		/>
		<polygon fill="#c8d838" points="150.35 132.55 156.04 136.45 159.94 120.26 156.64 119.36 150.35 132.55" />
	</svg>
);

export default FlagWorld;
